import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "panel" }

import { ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { getValueInUserLanguage } from '@/core/languageContent';
import PageLayout from '@/core/components/PageLayout.vue';
import ResourceTable from '@/core/components/resource/ResourceTable.vue';
import Column from '@/core/components/resource/Column';
import ActionColumn from '@/core/components/resource/ActionColumn';
import { News, newsUserTypes, useNews } from '@/modules/news/News';
import { dateTime } from '@/core/date';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsIndex',
  setup(__props) {

const { $gettext } = useGettext();
const resource = useNews();
const newsToDelete = ref<News>();
const deleteName = () => {
	if (!newsToDelete.value) {
		return '';
	}

	return getValueInUserLanguage(newsToDelete.value?.content, 'headline');
};

const columns = [
	new Column<News>($gettext('Namn'), 'content', 'headline', '+')
		.withFormatter(row => getValueInUserLanguage(row.content, 'headline') as string),
	new Column<News>($gettext('Publik'), 'user_type')
		.withFormatter(row => row.user_type.map(ut => newsUserTypes[ut]).join(', ')),
	new Column<News>($gettext('Skapad'), 'created_time', 'created_time')
		.withFormatter(row => dateTime(row.created_time)),
	new ActionColumn<News>()
		.withEditLink((tc) => ({ name: 'news.edit', params: { id: tc.id } }))
		.withDeleteLink((tc: News) => {
			newsToDelete.value = tc;
		}),
];

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('Nyheter')
  }, {
    "header-actions": _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
        to: {name: 'news.create'},
        class: "button"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Ny nyhet ", -1)
        ]))]),
        _: 1
      })), [
        [_directive_translate]
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ResourceTable, {
          resource: _unref(resource),
          columns: columns,
          "delete-title": _unref($gettext)('Ta bort nyhet'),
          "delete-name-key": deleteName,
          "to-delete": newsToDelete.value,
          "onUpdate:toDelete": _cache[0] || (_cache[0] = ($event: any) => ((newsToDelete).value = $event))
        }, null, 8, ["resource", "delete-title", "to-delete"])
      ])
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})